import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { id: "random" }, [
  /*#__PURE__*/_createElementVNode("path", {
    id: ".fill",
    d: "M21.7254 15.7745C22.0915 16.1407 22.0915 16.7343 21.7254 17.1004L18.6004 20.2247C18.0141 20.8111 17 20.4001 17 19.5618V18H14.7037C14.6394 18 14.5758 17.9867 14.5169 17.9611C14.4579 17.9355 14.4049 17.8981 14.361 17.8511L11.6049 14.8981L13.6882 12.666L15.75 14.875H17V13.3132C17 12.4758 18.0134 12.0633 18.6004 12.6503L21.7254 15.7745ZM2.46875 8.62499H5.74999L7.81175 10.834L9.89507 8.60187L7.13898 5.6489C7.09512 5.60191 7.04206 5.56444 6.98311 5.53882C6.92415 5.51321 6.86056 5.49999 6.79628 5.49999H2.46875C2.20988 5.49999 2 5.70988 2 5.96874V8.15624C2 8.41511 2.20988 8.62499 2.46875 8.62499ZM17 8.62499V10.1869C17 11.0251 18.0141 11.4361 18.6004 10.8498L21.7254 7.72542C22.0915 7.35929 22.0915 6.7657 21.7254 6.3996L18.6004 3.27535C18.0134 2.68832 17 3.10086 17 3.93824V5.49999H14.7037C14.6394 5.5 14.5758 5.51322 14.5169 5.53884C14.4579 5.56445 14.4049 5.60192 14.361 5.6489L5.74999 14.875H2.46875C2.20988 14.875 2 15.0849 2 15.3437V17.5312C2 17.7901 2.20988 18 2.46875 18H6.79628C6.9262 18 7.05031 17.946 7.13898 17.8511L15.75 8.62499H17Z"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }